export default "/images/e9fe9b75c58a4166acf2f5c68060061d.avif";